import { MediaViewerPage } from '@jarvis/platform-ui';

export function VideoViewerPage() {
  return <MediaViewerPage kind="video" filesLinkTo="/files" filesLinkLabel="Files" />;
}
